import { Component, OnInit, Input } from '@angular/core';
import { FormatoAsistencialEntity, FiltrosFormatoAsistencialEntity, NodoEntity } from 'src/app/services/servicio-formato-asistencial.service';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-diagnostico',
  templateUrl: './diagnostico.component.html',
  styleUrls: ['./diagnostico.component.css']
})
export class DiagnosticoComponent implements OnInit {

  @Input() data: FormatoAsistencialEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;
  @Input() nodo: NodoEntity;

  titulo: string;
  diagnosticos: any[];

  private HEADERS = new HttpHeaders ({ 'Content-Type' : 'application/json'});

  constructor( private http: HttpClient) { }

  ngOnInit() {
    if(this.nodo && this.filtros) {
      this.onProcess();
    } else {
      this.titulo = '';
      this.diagnosticos = [];
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    this.getDiagnosticosValue();
  }

  async getDiagnosticosValue() {
    const url =  `${environment.API_REPORTES}/formato-asistencial/diagnostico`;
    const body: any = {
      codigoBaseDatos: this.filtros.codigoBaseDatos,
      tta : this.filtros.tta,
      nodo : {
        id : this.nodo.id
      }
    }

    const request = await this.http.post(url, body, { headers : this.HEADERS });
    if (request) {
      request.subscribe((response: any) => {
        this.diagnosticos = response;
      }, (err: HttpErrorResponse) => {
        console.error('Error getDiagnosticoValue()', err);
        this.diagnosticos = [];
      });
    }
  }

}
